<template>
    <div>
        <div class="header">
            <div class="logout-bg" @click="logout">
                ログアウト
            </div>
            <div class="header-countdown-time">
                {{ countdownTimeStr }}
            </div>
            <div class="login-bg" @click="unSelect" v-if="selectCarFlag || selectNoCarFlag">
                選択解除
            </div>
            <div class="header-title">車両検索</div>

        </div>
        <div style="display: table;margin: 3vw auto 0 auto;background: #FFFFFF">

        </div>
        <div class="container" >

            <table style="display: table;margin: 1vw auto;background: #FFFFFF">
                <thead>
                    <th class="container-th" style="position: sticky;z-index: 1;top:-2px;" v-for="item in columns" v-bind:key="item.field">{{ item.label }}</th>
                </thead>
                <tbody>
                <tr v-for="(item,index) in rows" v-bind:key="item.carId"
                    :class="selectCarFlag && selectedIndex===index?'container-tr-bg-3':index%2===0?'container-tr-bg':'container-tr-bg-2'">
                  <div :class="selectCarFlag  && selectedIndex===index?'container-tr-id-selected':'container-tr-id'">
                    <a :class="selectCarFlag  && selectedIndex===index?'container-tr-id-text-selected':'container-tr-id-text'"
                       href="#" @click="itemClick(index)">{{ item.carId }}</a></div>
                  <div :class="selectCarFlag  && selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
                    {{item.carName}}
                  </div>
                  <div :class="selectCarFlag  && selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
                    {{item.number}}
                  </div>
                  <div :class="selectCarFlag && selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
                    {{ item.registeredStore }}
                  </div>
                  <div :class="selectCarFlag && selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
                    {{ item.inspectionDate }}
                  </div>

                </tr>
                </tbody>

            </table>
            <div v-if="rows.length === 0" class="container-empty">該当データはありません</div>
        </div>
        <div style="display: none;" class="no-car-bg" @click="noCarClick">上記に依頼する該当車両がない</div>
        <div class="car-selected-bg"> {{selectedMessage || '依頼されている車両の車両IDを選択してください。'}}</div>
        <div style="display: flex;margin-right: 4vw;margin-left: 4vw;">
            <div :class="type=== 2?'btn-bg-left':'btn-bg-left-unselect'" @click="carCheck(2)">車検</div>
            <div :class="type=== 4?'btn-bg-middle':'btn-bg-middle-unselect'"  @click="carCheck(4)">法定点検</div>
            <div :class="type=== 3?'btn-bg-middle':'btn-bg-middle-unselect'" @click="carCheck(3)">一般整備</div>
            <div :class="type=== 1?'btn-bg-right':'btn-bg-right-unselect'" @click="carCheck(1)">査定</div>
        </div>
        <div style="height: 2vw"></div>
        <custom-dialog v-show="showMessage" :show-message="showMessage" :sub-message='subMessage'
                       @dialogClick="dialogClick" :type="dialogType"/>
    </div>
</template>
<script>

import {EXIT_DATA_SAVE_TIPS} from "@/store/message";
import CustomDialog from "@/components/CustomDialog.vue";
import {addGeneralOrder, searchCarList} from "@/utils/api";
import {SHOP_ID} from "@/store/mutation-types";

export default {
    name: 'carSearchIndex',
    components: {
        CustomDialog
    },
    data() {
        return {
            countdownTime: 600,
            countdownTimeStr: '',
            searchKey: '',
            columns: [
                {
                    label: '車両ID',
                    field: 'carId',
                },
                {
                    label: '車名',
                    field: 'carName',
                },
                {
                    label: 'ナンバープレート',
                    field: 'number',
                },
                {
                    label: '登録店',
                    field: 'registeredStore',
                },
                {
                    label: '最終査定日付',
                    field: 'inspectionDate',
                },
            ],
            selectedIndex: '',
            rows:[],

            // rows: [
            //     {
            //         "carId": 1,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 2,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 3,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     }, {
            //         "carId": 4,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 5,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 6,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 7,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 8,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 9,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     },
            //     {
            //         "carId": 10,
            //         "carName": "望月 孝之",
            //         "vin": "000-000-0000",
            //         "registeredStore": "石坂SS",
            //     }
            // ],

            dialogType: 0,
            showMessage: false,
            subMessage: "",
            selectedMessage:'',
            selectNoCarFlag:false,
            selectCarFlag:false,
            state: 0,
            taskId: null,
            customerId:'',
            type:-1,
        }
    },
    mounted() {
        let that = this;
        that.taskId = setInterval(function () {
            that.countdown();

        }, 1000);
        if (that.$route.params.customerId){
            that.$set(that, 'customerId', that.$route.params.customerId)
            const loadingInstance1 = that.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
            });
            searchCarList(that.$route.params.customerId)
                .then(function (res){
                    console.log(JSON.stringify(res));
                    if (res && res.data && res.data.length > 0){
                        that.$set(that,'rows',res.data)
                    }else {
                        that.$set(that,'rows',[])
                    }
                   loadingInstance1.close();
                })
                .catch(function (err){
                    console.error(err)
                   loadingInstance1.close();
                })
        }
    },
    beforeDestroy() {
        clearInterval(this.taskId)
    },
    created() {
        let that = this;

        document.addEventListener('touchstart', function () {
            that.handleTouchStart()
        }, true);

    },
    methods: {
        countdown() {
            let that = this;
            let diff = that.countdownTime;
            diff--;
            if (diff <= 0) {
                window.document.location = "/ss/menu.php";
                clearInterval(that.taskId)
                return
            }

            let minutes = Math.floor((diff / 60));
            let seconds = Math.floor((diff % 60));
            that.$set(that, 'countdownTimeStr', `${minutes}:${seconds<10?'0'+seconds:seconds}`)
            that.$set(that, 'countdownTime', diff)
        },
        handleTouchStart() {
            console.log('handleTouchStart')
            if (this.countdownTime !== 600) {
                this.$set(this, 'countdownTime', 600)
            }
        },
        logout() {
            this.state = -1;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)

        },
        back() {
            this.state = -2;
            this.showMessageDialog(EXIT_DATA_SAVE_TIPS, 2)
        },
        dialogClick(val) {
            this.$set(this, 'showMessage', false)
            this.$set(this, 'subMessage', '')
            console.log('val:'+val)
            if (val) {
                if (this.state === -1) {
                    window.document.location = "/ss/menu.php";
                } else if (this.state === -2) {
                    this.$router.back();
                }else if (this.state === 1){
                    this.$set(this,'selectedMessage','依頼されている車両の車両IDを選択してください。')
                    this.$set(this,'selectNoCarFlag', true)
                    this.$set(this, 'selectedIndex', -1)
                    this.$set(this, 'selectCarFlag', false)
                }else if (this.state === 2){
                    this.$set(this,'selectedMessage','この車両を選択します。下のサービスのいずれかを選択してください')
                    this.$set(this,'selectCarFlag', true)
                }else if (this.state === 3){
                    this.uploadData(this.type,null)
                }
            }else {
                if (this.state === 2){
                    this.$set(this,'selectedMessage','依頼されている車両の車両IDを選択してください。')
                    this.$set(this, 'selectedIndex', -1)
                    this.$set(this, 'selectCarFlag', false)
                }else if (this.state === 3){
                    this.$set(this, 'type', -1)
                }
            }
            this.$set(this, 'state', 0)
        },
        showMessageDialog(subMessage, dialogType) {
            this.$set(this, 'showMessage', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },
        itemClick(index) {
            if(this.selectedIndex !== index){
                this.$set(this, 'selectCarFlag', false)
                this.$set(this, 'selectedIndex', index)
                this.state = 2;
                this.showMessageDialog('選択の車両を指定しますか', 2)
            }

        },
        unSelect() {
            this.$set(this,'selectedMessage','依頼されている車両の車両IDを選択してください。')
            this.$set(this, 'selectedIndex', -1)
            this.$set(this, 'selectCarFlag', false)
        },
        noCarClick() {
            this.state = 1;
            this.showMessageDialog('車両を選択しないで進みますか', 2)
        },
        carCheck(type){
            var that = this;
            let carId = null;
            that.$set(that,'type',type)
            if (that.selectCarFlag){
                carId = that.rows[that.selectedIndex].carId;
            }else if (that.selectNoCarFlag){
                carId = null
            }
            if (carId === null){
                that.$set(that,'state',3)
                that.showMessageDialog('車両を選択しないで進みますか。', 2)
                return
            }
            that.uploadData(type,carId)
        },
        uploadData(type,carId){
            var that = this;
            if (type === 3){
                const loadingInstance1 = that.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                });
                addGeneralOrder(localStorage.getItem(SHOP_ID),that.customerId,carId,3)
                    .then(function (res){
                        console.log(JSON.stringify(res))

                       loadingInstance1.close();
                        that.$router.push("/pr");
                    })
                    .catch(function (err){
                        console.error(err)
                        loadingInstance1.close();
                    })
            }else {
                that.$router.push('/enquiteIndex/'+that.customerId+"/"+type+"/"+carId)
            }
        }

    }
}
</script>

<style scoped>
.header {
    background: #416ADB;
    height: 8vw;
}

.header-title {
    color: white;
    font-size: 3vw;
    height: 8vw;
    line-height: 8vw;
    margin: 0 auto;
}

.header-countdown-time {
    display: flex;
    color: white;
    font-size: 2.2vw;
    position: absolute;
    float: right;
    right: 0;
    margin-top: 1.5vw;
    margin-right: 3.5vw;
}

.container {
    text-align: center;
    height: 40vh;
    margin: 1vw auto 1vw auto;
    overflow: auto;
}

.container-empty {
    width: 100%;
    height: 32vw;
    line-height: 32vw;
    text-align: center;
    margin: 0 auto;
    font-size: 2.4vw;
}

.container-th {
    min-width: 17vw;
    background: #89a4ca;
    color: #FFFFFF;
    font-size: 2.4vw;
    padding: 0.8vw;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}

.container-tr-id {
    min-width: 17vw;
    max-width: 17vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    color: #083a7e;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
}

.container-tr-id-selected {
    min-width: 17vw;
    max-width: 17vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    color: #ffffff;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
}

.container-tr-id-text {
    color: #083a7e;
}

.container-tr-id-text-selected {
    color: #ffffff;
}

.container-tr-content-selected {
    font-size: 2.4vw;
    min-width: 17vw;
    max-width: 17vw;
    padding: 0.8vw;
    text-align: left;
    color: #FFFFFF;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
    vertical-align: middle;
}

.container-tr-content {
    min-width: 17vw;
    max-width: 17vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    text-align: left;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
    vertical-align: middle;
    overflow-wrap: anywhere;
}

.container-tr-bg {
    background: #cfddee;
}

.container-tr-bg-2 {
    background: #e8f1fb;
}

.container-tr-bg-3 {
    background: #083a7e;
}

.div-customer-search {
    width: 100vw;
    height: 8vw;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2vw;
}

.input-customer-name {
    padding-left: 1vw;
    width: 30vw;
    border: 0.3vw #083A7E solid;
    border-radius: 0.8vw;
    height: 4vw;
    color: #212529;
    padding-top: 0.5vw;
    padding-bottom: 0.5vw;
    font-size: 2.4vw;
}

.btn-bg-search {
    height: 3.6vw;
    margin-left: 3vw;
    background: #f7bc34;
    font-size: 3vw;
    text-align: center;
    align-items: center;
    padding: 1vw 2.5vw 1vw 2.5vw;
    border-radius: 0.8vw;
    color: #212529;
    border-width: 0.4vw;
    border-color: #93721f;
    border-style: none none solid none;
}

.no-car-bg {
    border: #083A7E 0.2vw solid;
    padding: 0.5vw 1vw;
    font-size: 2.4vw;
    color: #083A7E;
    position: absolute;
    right: 0;
    margin: 1vw 4vw;
}

.car-selected-bg {
    margin: 8vw auto 4vw auto;
    font-size: 2.4vw;
    color: #808080;
}

.logout-bg {
    margin: 1.5vw 3vw;
    background: #e7373d;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #891F25;
    border-style: none none solid none;
    position: absolute;
}

.login-bg {
    margin: 1.5vw 3vw;
    background: #78a950;
    font-size: 2.4vw;
    padding: 0.8vw 5vw;
    border-radius: 0.8vw;
    color: #FFFFFF;
    border-width: 0.4vw;
    border-color: #486630;
    border-style: none none solid none;
    position: absolute;
    right: 10vw;
}


.btn-bg {
    margin: 2vw auto;
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    width: 40vw;
}

.btn-bg-left {
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    flex: 1;
    margin: 0 2vw;
}
.btn-bg-left-unselect {
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border: #000000 solid 0.2vw;

    background: #FFFFFF;
    color: #000000;
    font-size: 3vw;
    flex: 1;
    margin: 0 2vw;
}

.btn-bg-right {
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    flex: 1;
    margin: 0 2vw;
}
.btn-bg-right-unselect {
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border: #000000 solid 0.2vw;

    background: #FFFFFF;
    color: #000000;
    font-size: 3vw;
    flex: 1;
    margin: 0 2vw;
}

.btn-bg-middle {
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border-bottom: #083A7E 0.2vw;
    border-style: none none solid none;
    background: #416ADA;
    color: #FFFFFF;
    font-size: 3vw;
    flex: 1;
    margin: 0 2vw;
}
.btn-bg-middle-unselect {
    padding: 1vw;
    border-radius: 1vw;
    opacity: 1;
    border: #000000 solid 0.2vw;
    background: #FFFFFF;
    color: #000000;
    font-size: 3vw;
    flex: 1;
    margin: 0 2vw;
}
</style>